import { atom, selector } from 'recoil';
import { ConfigurationService } from 'api';
export const getSanctionedCountriesRequestId = atom({
  key: 'getSanctionedCountriesRequestId',
  default: 0
});
export const sanctionedCountriesState = selector({
  key: 'sanctionedCountriesState',
  get: async ({
    get
  }) => {
    get(getSanctionedCountriesRequestId);
    return ConfigurationService.getSanctionedCountries();
  }
});
export const getSanctionedCountries = selector({
  key: 'getSanctionedCountries',
  get: async ({
    get
  }) => {
    get(getSanctionedCountriesRequestId);
    try {
      return await ConfigurationService.getSanctionedCountries();
    } catch (e) {
      console.error(e);
    }
    return {};
  }
});